/* eslint-disable react/prop-types */
function Card1(props) {
  const { fillColor, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="130"
      height="194"
      viewBox="0 0 130 194"
      className={className || 'light-card-shadow'}
    >
      <g id="Group_1606" data-name="Group 1606" transform="translate(-1746 -8404.261)">
        <path
          id="Path_2330"
          data-name="Path 2330"
          d="M1746,8420.428a16.257,16.257,0,0,1,16.25-16.167h97.5a16.256,16.256,0,0,1,16.25,16.167v161.666a16.256,16.256,0,0,1-16.25,16.167h-97.5a16.256,16.256,0,0,1-16.25-16.167Z"
          fill="#fff"
        />
        <g id="Group_498" data-name="Group 498">
          <path
            id="Path_2331"
            data-name="Path 2331"
            d="M1838.756,8579.271l-.014.015.014.015Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2332"
            data-name="Path 2332"
            d="M1838.756,8542.625h0l-.014.014.014.015Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2333"
            data-name="Path 2333"
            d="M1838.756,8553.9l-.014.015.014.014Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2334"
            data-name="Path 2334"
            d="M1838.756,8590.548l-.014.015.014.015Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2335"
            data-name="Path 2335"
            d="M1838.756,8505.979h0l-.014.015.014.015Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2336"
            data-name="Path 2336"
            d="M1838.756,8517.256l-.014.015.014.015Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2337"
            data-name="Path 2337"
            d="M1838.756,8469.333h0l-.014.015.014.014Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2338"
            data-name="Path 2338"
            d="M1838.756,8480.61l-.014.015.014.015Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2339"
            data-name="Path 2339"
            d="M1866.25,8524.253v-4.262l-18.832-18.737,18.832-18.744v-4.256l-23.118,23Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2340"
            data-name="Path 2340"
            d="M1866.25,8515.721v-4.256l-10.264-10.211,10.264-10.212v-4.264l-14.548,14.476Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2341"
            data-name="Path 2341"
            d="M1866.25,8507.2v-4.27l-1.687-1.68,1.687-1.687V8495.3l-5.978,5.949Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2342"
            data-name="Path 2342"
            d="M1838.841,8501.254h0l-27.852,27.716,0,0,27.848,27.707,27.409-27.262v-.9l-27.409-27.269Zm2.144,19.192,4.284-4.27-6.428-6.39-8.57,8.523,19.282,19.184,2.147-2.133,6.43-6.392-6.43-6.4-2.147,2.138-2.144,2.126,2.144,2.133,2.147-2.133,2.146,2.133-4.293,4.263-2.144-2.126-4.277-4.27,8.568-8.526,10.707,10.659-23.566,23.447-10.717-10.652,8.571-8.532,6.437,6.393-4.291,4.269-2.146-2.129,2.146-2.14-2.146-2.131-4.28,4.271,6.426,6.391,8.568-8.53-19.285-19.179-8.567,8.523,6.43,6.392,4.284-4.255-2.147-2.137-2.137,2.137-2.146-2.137,4.283-4.26,6.433,6.4-8.57,8.519-10.714-10.655,23.568-23.454,10.712,10.661-8.567,8.533-6.429-6.4,4.284-4.262,2.144,2.128-2.144,2.134Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2343"
            data-name="Path 2343"
            d="M1866.25,8579.679v-4.262l-18.832-18.738,18.832-18.744v-4.255l-23.118,23Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2344"
            data-name="Path 2344"
            d="M1866.25,8571.146v-4.256l-10.264-10.212,10.264-10.211V8542.2l-14.548,14.476Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2345"
            data-name="Path 2345"
            d="M1866.25,8562.629v-4.27l-1.687-1.681,1.687-1.686v-4.264l-5.978,5.949Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2346"
            data-name="Path 2346"
            d="M1810.993,8524.7l23.568-23.447-23.568-23.447-23.569,23.447Zm19.284-23.447-19.284,19.187-19.283-19.187,19.283-19.191Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2347"
            data-name="Path 2347"
            d="M1810.993,8516.171l15-14.914-15-14.923-15,14.923Zm10.716-14.914-10.716,10.66-10.715-10.66,10.715-10.659Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2348"
            data-name="Path 2348"
            d="M1810.993,8507.655l6.43-6.4-6.43-6.4-6.429,6.4Zm2.139-6.4-2.139,2.129-2.138-2.129,2.138-2.135Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2349"
            data-name="Path 2349"
            d="M1851.7,8578l-2.146,2.138-2.144,2.127,2.144,2.133,2.146-2.133,2.146,2.133-4.2,4.166h4.288l4.191-4.166Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2350"
            data-name="Path 2350"
            d="M1819.557,8584.4l4.191,4.166h4.479l2.044-2.03-2.147-2.136-2.137,2.136-2.146-2.136,4.284-4.26,6.433,6.4-2.042,2.03h8.368l-12.759-12.689Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2351"
            data-name="Path 2351"
            d="M1810.989,8584.4l0,0,4.183,4.161h4.286l-4.189-4.164,23.568-23.455,10.712,10.661-8.567,8.533-6.429-6.4,4.284-4.263,2.144,2.129-2.144,2.134,2.144,2.136,4.284-4.27-6.428-6.39-8.57,8.523,14.9,14.824h4.284l-2.047-2.029-4.277-4.27,8.568-8.525,10.707,10.66-4.186,4.164h1.529a6.582,6.582,0,0,0,6.26-4.853l-27.169-27.028Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2352"
            data-name="Path 2352"
            d="M1810.993,8528.973l0,0-27.855-27.712h0l-27.383,27.249v.934l27.383,27.242Zm-30.006,8.524-4.279,4.271,6.426,6.392,8.567-8.531-19.284-19.178-8.568,8.522,6.43,6.392,4.284-4.255-2.146-2.137-2.138,2.137-2.146-2.136,4.284-4.26,6.432,6.4-8.57,8.519-10.714-10.655,23.568-23.454,10.712,10.662-8.567,8.533-6.429-6.4,4.285-4.263,2.144,2.129-2.145,2.134,2.145,2.136,4.283-4.27-6.428-6.391-8.57,8.524,19.282,19.183,2.147-2.133,6.43-6.391-6.43-6.4-2.147,2.138-2.144,2.126,2.144,2.134,2.147-2.134,2.146,2.133-4.293,4.264-2.144-2.127-4.277-4.27,8.568-8.525,10.707,10.658-23.566,23.448-10.716-10.653,8.57-8.531,6.437,6.392-4.291,4.27-2.146-2.13,2.146-2.14Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2353"
            data-name="Path 2353"
            d="M1810.993,8580.13l23.568-23.447-23.568-23.447-23.569,23.447Zm19.284-23.447-19.284,19.186-19.283-19.186,19.283-19.192Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2354"
            data-name="Path 2354"
            d="M1810.993,8571.6l15-14.914-15-14.924-15,14.924Zm10.716-14.914-10.716,10.659-10.715-10.659,10.715-10.659Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2355"
            data-name="Path 2355"
            d="M1810.993,8563.08l6.43-6.4-6.43-6.4-6.429,6.4Zm2.139-6.4-2.139,2.128-2.138-2.128,2.138-2.136Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2356"
            data-name="Path 2356"
            d="M1755.75,8478.276v4.255l18.819,18.729-18.819,18.723v4.262l23.1-22.984Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2357"
            data-name="Path 2357"
            d="M1755.75,8486.8v4.265l10.251,10.2-10.251,10.2v4.255l14.535-14.451Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2358"
            data-name="Path 2358"
            d="M1755.75,8495.326v4.264l1.674,1.671-1.674,1.665v4.27l5.965-5.935Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2359"
            data-name="Path 2359"
            d="M1810.989,8584.4l-27.856-27.714-27.146,27.015a6.582,6.582,0,0,0,6.263,4.863h1.5l-4.185-4.161,23.568-23.454,10.712,10.661-8.567,8.532-6.429-6.4,4.285-4.263,2.144,2.129-2.145,2.134,2.145,2.135,4.283-4.269-6.428-6.391-8.57,8.524,14.9,14.82h4.284l-2.044-2.025-4.277-4.27,8.568-8.525L1806.7,8584.4l-4.183,4.161h4.292l4.185-4.161Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2360"
            data-name="Path 2360"
            d="M1763.849,8584.4l4.188,4.162h4.486l2.04-2.026-2.146-2.136-2.138,2.136-2.146-2.136,4.284-4.26,6.432,6.4-2.038,2.026h8.361l-12.756-12.687Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2361"
            data-name="Path 2361"
            d="M1795.992,8578l-2.147,2.138-2.144,2.126,2.144,2.134,2.147-2.134,2.146,2.134-4.192,4.162h4.288l4.188-4.162Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2362"
            data-name="Path 2362"
            d="M1866.25,8468.827v-4.261l-18.832-18.738,18.832-18.744v-4.255l-23.118,23Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2363"
            data-name="Path 2363"
            d="M1866.25,8460.295v-4.255l-10.264-10.212,10.264-10.211v-4.265l-14.548,14.476Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2364"
            data-name="Path 2364"
            d="M1866.25,8451.777v-4.269l-1.687-1.681,1.687-1.686v-4.264l-5.978,5.949Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2365"
            data-name="Path 2365"
            d="M1838.841,8445.829h0l-27.852,27.716,0,0,27.848,27.706h0l27.409-27.262v-.9l-27.409-27.268Zm2.144,19.192,4.284-4.27-6.428-6.39-8.57,8.522,19.282,19.184,2.147-2.134,6.43-6.39-6.43-6.4-2.147,2.138-2.144,2.127,2.144,2.133,2.147-2.133,2.146,2.133-4.293,4.262-2.144-2.127-4.277-4.269,8.568-8.526,10.707,10.66-23.566,23.447-10.717-10.652,8.571-8.533,6.437,6.393-4.291,4.269-2.146-2.128,2.146-2.141-2.146-2.131-4.28,4.271,6.426,6.391,8.568-8.531-19.285-19.178-8.567,8.523,6.43,6.39,4.284-4.255-2.147-2.135-2.137,2.135-2.146-2.135,4.283-4.26,6.433,6.395-8.57,8.52-10.714-10.654,23.568-23.455,10.712,10.662-8.567,8.533-6.429-6.4,4.284-4.262,2.144,2.129-2.144,2.133Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2366"
            data-name="Path 2366"
            d="M1838.841,8501.254h0Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2367"
            data-name="Path 2367"
            d="M1810.993,8469.279l23.568-23.447-23.568-23.448-23.569,23.448Zm19.284-23.447-19.284,19.185-19.283-19.185,19.283-19.193Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2368"
            data-name="Path 2368"
            d="M1810.993,8460.746l15-14.914-15-14.924-15,14.924Zm10.716-14.914-10.716,10.659-10.715-10.659,10.715-10.66Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2369"
            data-name="Path 2369"
            d="M1810.993,8452.229l6.43-6.4-6.43-6.4-6.429,6.4Zm2.139-6.4-2.139,2.128-2.138-2.128,2.138-2.136Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2370"
            data-name="Path 2370"
            d="M1783.133,8501.257h0l27.859-27.71,0,0-27.855-27.713h0l-27.383,27.25v.933l27.383,27.243Zm-2.146-19.185-4.279,4.271,6.426,6.392,8.567-8.531-19.284-19.179-8.568,8.523,6.43,6.392,4.284-4.256-2.146-2.136-2.138,2.136-2.146-2.136,4.284-4.26,6.432,6.4-8.57,8.52-10.714-10.655,23.568-23.454,10.712,10.661-8.567,8.533-6.429-6.4,4.285-4.262,2.144,2.129-2.145,2.133,2.145,2.136,4.283-4.27-6.428-6.39-8.57,8.523,19.282,19.184,2.147-2.133,6.43-6.392-6.43-6.4-2.147,2.138-2.144,2.126,2.144,2.133,2.147-2.133,2.146,2.133-4.293,4.262-2.144-2.126-4.277-4.269,8.568-8.526,10.707,10.659L1783.133,8497l-10.716-10.652,8.57-8.533,6.437,6.394-4.291,4.269-2.146-2.129,2.146-2.14Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2371"
            data-name="Path 2371"
            d="M1783.133,8501.258h0Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2372"
            data-name="Path 2372"
            d="M1755.75,8422.851v4.256l18.819,18.729-18.819,18.723v4.262l23.1-22.984Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2373"
            data-name="Path 2373"
            d="M1755.75,8431.375v4.264l10.251,10.2-10.251,10.2v4.255l14.535-14.452Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2374"
            data-name="Path 2374"
            d="M1755.75,8439.9v4.264l1.674,1.671-1.674,1.666v4.269l5.965-5.935Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2375"
            data-name="Path 2375"
            d="M1859.75,8413.961h-1.52l4.177,4.158-23.566,23.447-10.717-10.652,8.571-8.533,6.437,6.394-4.291,4.269-2.146-2.129,2.146-2.14-2.146-2.132-4.28,4.271,6.426,6.391,8.568-8.53-14.9-14.813h-4.287l6.33,6.294-8.57,8.52-10.714-10.655,4.178-4.158h-4.283l-4.179,4.158,0,0,27.848,27.706h0l27.167-27.021A6.583,6.583,0,0,0,1859.75,8413.961Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2376"
            data-name="Path 2376"
            d="M1851.7,8424.51l6.43-6.391-4.18-4.158h-4.5l-2.042,2.025,2.144,2.133,2.146-2.133,2.146,2.133-4.293,4.263-2.144-2.127-4.277-4.269,2.035-2.025h-8.361l12.747,12.683Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2377"
            data-name="Path 2377"
            d="M1825.987,8424.51l4.284-4.255-2.147-2.136-2.137,2.136-2.146-2.136,4.182-4.158h-4.286l-4.179,4.158Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2378"
            data-name="Path 2378"
            d="M1838.841,8445.828h0Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2379"
            data-name="Path 2379"
            d="M1770.279,8424.514l4.284-4.256-2.146-2.135-2.138,2.135-2.146-2.135,4.185-4.162h-4.286l-4.183,4.162Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2380"
            data-name="Path 2380"
            d="M1783.133,8445.832h0l27.859-27.709,0,0-4.18-4.158h-4.29l4.18,4.162-23.566,23.447-10.716-10.652,8.57-8.533,6.437,6.394-4.291,4.269-2.146-2.129,2.146-2.14-2.146-2.131-4.279,4.271,6.426,6.39,8.567-8.529-14.9-14.817h-4.287l6.333,6.3-8.57,8.521-10.714-10.655,4.182-4.162h-1.5a6.583,6.583,0,0,0-6.263,4.864l27.146,27.007Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2381"
            data-name="Path 2381"
            d="M1795.992,8424.514l6.43-6.391-4.183-4.162h-4.493l-2.046,2.028,2.144,2.134,2.147-2.134,2.146,2.134-4.293,4.262-2.144-2.127-4.277-4.269,2.038-2.028h-8.368l12.751,12.686Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2382"
            data-name="Path 2382"
            d="M1783.133,8445.832h0Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2383"
            data-name="Path 2383"
            d="M1755.75,8533.7v4.255l18.819,18.729-18.819,18.723v4.262l23.1-22.984Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2384"
            data-name="Path 2384"
            d="M1755.75,8542.226v4.265l10.251,10.2-10.251,10.2v4.255l14.535-14.451Z"
            fill={fillColor || '#8ea5ab'}
          />
          <path
            id="Path_2385"
            data-name="Path 2385"
            d="M1755.75,8550.752v4.264l1.674,1.671-1.674,1.665v4.27l5.965-5.935Z"
            fill={fillColor || '#8ea5ab'}
          />
        </g>
      </g>
    </svg>
  );
}

export default Card1;
